import React, { useState, useEffect } from "react"
import { Breadcrumb, Layout, Menu, Modal, Popover, Select, Switch, Tabs } from 'antd';
import images from '../../themes/appImage'
import { BrowserRouter as Router, Link, useNavigate } from "react-router-dom";
import appconstant from "../../themes/appconstant";
import Textfiled from "../../common";



const { Header, Content, Footer, Sider } = Layout;

const handleChange = (value) => {
    console.log(`selected ${value}`);
};

const UsersReport
    = () => {

        const navigate = useNavigate()
        // tab switch
        const [selectedTab, setSelectedTab] = useState(1);

        // popover 
        const [open, setOpen] = useState(false);
        const hide = () => {
            setOpen(false);
        };
        const handleOpenChange = (newOpen) => {
            setOpen(newOpen);
        };
        // end popover

        // 
        const [open1, setOpen1] = useState(false);
        const hide1 = () => {
            setOpen1(false);
        };

        const handleOpenChange1 = (newOpen) => {
            setOpen1(newOpen);
        };

        // 


        useEffect(() => {
            document.title = 'MentalFit';
        }, [])

        // switch
        const onChange3 = (checked) => {
            console.log(`switch to ${checked}`);
        };

        // 


        // modale

        const [modal1Open, setModal1Open] = useState(false);
        const [modal2Open, setModal2Open] = useState(false);
        const [modal3Open, setModal3Open] = useState(false);
        const [modal4Open, setModal4Open] = useState(false);
        const [modal5Open, setModal5Open] = useState(false);
        const [modal6Open, setModal6Open] = useState(false);
        const [modal7Open, setModal7Open] = useState(false);





        // 


        return (
            <div>
                <div className="site-layout-background" style={{ minHeight: 360 }}>

                    <div className="top-header-organi-zations">
                        <div className="organi-zations-heading-text">
                            <h1>Users</h1>
                            <p>Sed consectetur imperdiet facilisiulla malesua daeddiet facilisiulla</p>
                        </div>
                    </div>


                    <div className="user-main-section">
                        <div className="user-profile-div">
                            <div className="user-left-side-sec">
                                <div className="inner-section-ps">
                                    <div className="avt-profile-pic">
                                        <img src={images.profileSec} alt="profileSec" />
                                    </div>


                                    <div className="avatar-name">
                                        <h2>Annette Black</h2>
                                        <p>Bessie_Cooper12</p>
                                        <div className="avatar-ranking">
                                            <img src={images.welcomeIcon} alt="welcomeIcon" />
                                            <img src={images.thoughtIcon} alt="thoughtIcon" />
                                            <img src={images.goalIcon} alt="goalIcon" />
                                        </div>
                                    </div>

                                    <div className="followers-section">
                                        <div className="avatar-post-numbers">
                                            <div className="following-div border-line">
                                                <p>40</p>
                                                <span>Followers</span>
                                            </div>

                                            <div className="following-div border-line">
                                                <p>20</p>
                                                <span>Posts</span>
                                            </div>

                                            <div className="following-div">
                                                <p>10</p>
                                                <span>Following</span>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="work-on-most">
                                        <h1>Things I would like to work on most</h1>

                                        <div className="acceptance-care">
                                            <div className="beauty">
                                                <p>Acceptance</p>
                                                <p>Beauty</p>
                                                <p>Care</p>
                                            </div>
                                        </div>

                                        <div className="top-mt">
                                            <div className="coins">
                                                <p>Coins</p>
                                                <span><img src={images.coins} alt="coins" />500</span>
                                            </div>

                                            <div className="coins">
                                                <p>Email</p>
                                                <span>ckctm12@gmail.com</span>
                                            </div>

                                            <div className="coins">
                                                <p>Gender</p>
                                                <span>Male</span>
                                            </div>


                                            <div className="coins">
                                                <p>DOB </p>
                                                <span>March 23, 2013</span>
                                            </div>

                                            <div className="coins">
                                                <p>Visibility</p>
                                                <span>On</span>
                                            </div>

                                            <div className="coins">
                                                <p>WHO-5 Wellness Index</p>
                                                <span>200</span>
                                            </div>


                                            <div className="coins">
                                                <p>Streak</p>
                                                <span>50 Days</span>
                                            </div>
                                        </div>
                                        <div className="profile-freeze">
                                            <button onClick={() => setModal1Open(true)}>Freeze Profile</button>
                                            <button onClick={() => setModal3Open(true)}>Remove Profile</button>
                                        </div>
                                    </div>

                                    <div className="bottom-text">
                                        <p>Member Since: March 23, 2013 </p>
                                    </div>

                                </div>

                            </div>


                            <div className=" post-page-section">

                                <div className="gratitude-attitude-new-sec top-bottom-margin-sp">
                                    <div className="problem-type-hate">
                                        <div className="hate-speech">
                                            <div className="problem-type">
                                                <p>Report Reason</p>
                                                <h6>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore Lore m ipsum dolor sit amet, </h6>
                                            </div>
                                            <div className="post-cont">
                                                <Popover
                                                    content={
                                                        <div className="popup" style={{ width: "200px" }}>
                                                            <div onClick={() => { setModal6Open(true)  
                                                            setOpen1(false) }} className="edit-account">
                                                                <p><span><img src={images.crossSquar} alt="crossSquar" /></span>Remove User</p>
                                                            </div>
                                                            <div onClick={() => { setModal7Open(true) 
                                                            }} className="edit-account freeze-account">
                                                                <p><span><img src={images.freezeUserIcon} alt="freezeUserIcon" /></span>Freeze User</p>
                                                            </div>
                                                            <div className="edit-account freeze-account">
                                                                <p><span><img src={images.rightClick} alt="rightClick" /></span>Ignore</p>
                                                            </div>

                                                        </div>

                                                    }
                                                    title=""
                                                    trigger="click"
                                                    placement="bottomLeft"
                                                    overlayClassName="update-popup ignore-poup"
                                                    open={open1}
                                                    onOpenChange={handleOpenChange1}
                                                >

                                                    <img src={images.horizontalDots} alt="horizontalDots" />
                                                </Popover>

                                                {/* <img src={images.horizontalDots} /> */}
                                            </div>
                                        </div>

                                        <div className="annette-black-avatar">
                                            <div className="black-avatar">
                                                <p> <span><img src={images.maleTable} /> </span> Annette Black</p>
                                            </div>

                                            <div className="black-avatar-date">
                                                <p>March 23, 2013</p>

                                            </div>

                                        </div>

                                    </div>

                                </div>
                                <div className="slider-section slider-tab-div">
                                    <div className="tab-bar ">
                                        <Tabs>
                                            <Tabs.TabPane tab="Posts" key="1">

                                                <div className="post-page-width">
                                                    <div className="user-post post-top-sp ">

                                                        <div className="post-rmover-setting">
                                                            <div className="post-disp">
                                                                <div className="user-pofile">
                                                                    <img src={images.userProf} alt="userProf" />
                                                                </div>
                                                                <div className="user-name">
                                                                    <h2>John_adam06</h2>
                                                                    <p>1 hr ago</p>
                                                                </div>
                                                            </div>

                                                            <div className="update-btn-right padding-right">
                                                                <span>

                                                                    <Popover
                                                                        content={
                                                                            <div className="popup" style={{ width: "200px" }}>
                                                                                <div className="edit-account">
                                                                                    <p><span><img src={images.crossSquar} alt="lineDev" /></span>Remove Post</p>
                                                                                </div>


                                                                            </div>

                                                                        }
                                                                        title=""
                                                                        trigger="click"
                                                                        placement="bottomRight"
                                                                        overlayClassName="update-popup"
                                                                        open={open}
                                                                        onOpenChange={handleOpenChange}
                                                                    >

                                                                        <img src={images.dotesReact} alt="horizontalDots" />
                                                                    </Popover>
                                                                </span>
                                                            </div>

                                                        </div>



                                                        <div className="user-disp-text">
                                                            <p>Sometimes we make the process more complicated than we need to. We will never make a journey of a thousand miles.</p>
                                                        </div>

                                                        <div className="post-image user-post-radius">
                                                            <img src={images.post} alt="firstIcon" />
                                                        </div>

                                                    </div>


                                                    
                                                </div>


                                            </Tabs.TabPane>


                                            <Tabs.TabPane tab="Inner circles" key="2">

                                                <div className="inner-circle">
                                                    <div className="create-inner-section">


                                                        <div className="create-entertainment-circle">
                                                            <div className="enter-flex-ps">
                                                                <div className="enter-taain-heading">
                                                                    <h1>Entertainment</h1>
                                                                    <p><span><img src={images.redDot} alt="createCricl" />
                                                                    </span>Circle activity tomorrow at 10:00 AM</p>
                                                                </div>
                                                                <div className="dotes-react">
                                                                    {/* <img src={images.dotesReact} alt="dotesReact" /> */}

                                                                </div>

                                                            </div>

                                                            <div className="reation-imoze">
                                                                <div className="avatars">
                                                                    <span><img src={images.firstIcon} alt="firstIcon" /></span>
                                                                    <span><img src={images.avatarTow} alt="avatarTow" /></span>
                                                                    <span><img src={images.avatarThree} alt="avatarThree" /></span>
                                                                    <span><img src={images.avatarFour} alt="avatarfour" /></span>
                                                                    <span><img src={images.avatarFive} alt="avatarfour" /></span>
                                                                    <span className="get-more">+3</span>
                                                                </div>

                                                                <div className="back-button">
                                                                    <img src={images.backButton} alt="backButton" />
                                                                </div>
                                                            </div>

                                                            <div className="engagement-rate">
                                                                <div className="engage-text">
                                                                    <h5>Engagement Rate</h5>
                                                                </div>
                                                                <div className="per-rate">
                                                                    <span>90%</span>

                                                                </div>
                                                            </div>


                                                        </div>

                                                        <div className="create-entertainment-circle">
                                                            <div className="enter-flex-ps">
                                                                <div className="enter-taain-heading">
                                                                    <h1>Entertainment</h1>
                                                                    <p><span><img src={images.redDot} alt="createCricl" />
                                                                    </span>Circle activity tomorrow at 10:00 AM</p>
                                                                </div>
                                                                <div className="dotes-react">
                                                                    {/* <img src={images.dotesReact} alt="dotesReact" /> */}

                                                                </div>

                                                            </div>

                                                            <div className="reation-imoze">
                                                                <div className="avatars">
                                                                    <span><img src={images.firstIcon} alt="firstIcon" /></span>
                                                                    <span><img src={images.avatarTow} alt="avatarTow" /></span>
                                                                    <span><img src={images.avatarThree} alt="avatarThree" /></span>
                                                                    <span><img src={images.avatarFour} alt="avatarfour" /></span>
                                                                    <span><img src={images.avatarFive} alt="avatarfour" /></span>
                                                                    <span className="get-more">+3</span>
                                                                </div>

                                                                <div className="back-button">
                                                                    <img src={images.backButton} alt="backButton" />
                                                                </div>
                                                            </div>

                                                            <div className="engagement-rate">
                                                                <div className="engage-text">
                                                                    <h5>Engagement Rate</h5>
                                                                </div>
                                                                <div className="per-rate">
                                                                    <span>90%</span>

                                                                </div>
                                                            </div>


                                                        </div>


                                                        <div className="create-entertainment-circle">
                                                            <div className="enter-flex-ps">
                                                                <div className="enter-taain-heading">
                                                                    <h1>Entertainment</h1>
                                                                    <p><span><img src={images.redDot} alt="createCricl" />
                                                                    </span>Circle activity tomorrow at 10:00 AM</p>
                                                                </div>
                                                                <div className="dotes-react">
                                                                    {/* <img src={images.dotesReact} alt="dotesReact" /> */}

                                                                </div>

                                                            </div>

                                                            <div className="reation-imoze">
                                                                <div className="avatars">
                                                                    <span><img src={images.firstIcon} alt="firstIcon" /></span>
                                                                    <span><img src={images.avatarTow} alt="avatarTow" /></span>
                                                                    <span><img src={images.avatarThree} alt="avatarThree" /></span>
                                                                    <span><img src={images.avatarFour} alt="avatarfour" /></span>
                                                                    <span><img src={images.avatarFive} alt="avatarfour" /></span>
                                                                    <span className="get-more">+3</span>
                                                                </div>

                                                                <div className="back-button">
                                                                    <img src={images.backButton} alt="backButton" />
                                                                </div>
                                                            </div>

                                                            <div className="engagement-rate">
                                                                <div className="engage-text">
                                                                    <h5>Engagement Rate</h5>
                                                                </div>
                                                                <div className="per-rate">
                                                                    <span>90%</span>

                                                                </div>
                                                            </div>


                                                        </div>


                                                        <div className="create-entertainment-circle">
                                                            <div className="enter-flex-ps">
                                                                <div className="enter-taain-heading">
                                                                    <h1>Entertainment</h1>
                                                                    <p><span><img src={images.redDot} alt="createCricl" />
                                                                    </span>Circle activity tomorrow at 10:00 AM</p>
                                                                </div>
                                                                <div className="dotes-react">
                                                                    {/* <img src={images.dotesReact} alt="dotesReact" /> */}

                                                                </div>

                                                            </div>

                                                            <div className="reation-imoze">
                                                                <div className="avatars">
                                                                    <span><img src={images.firstIcon} alt="firstIcon" /></span>
                                                                    <span><img src={images.avatarTow} alt="avatarTow" /></span>
                                                                    <span><img src={images.avatarThree} alt="avatarThree" /></span>
                                                                    <span><img src={images.avatarFour} alt="avatarfour" /></span>
                                                                    <span><img src={images.avatarFive} alt="avatarfour" /></span>
                                                                    <span className="get-more">+3</span>
                                                                </div>

                                                                <div className="back-button">
                                                                    <img src={images.backButton} alt="backButton" />
                                                                </div>
                                                            </div>

                                                            <div className="engagement-rate">
                                                                <div className="engage-text">
                                                                    <h5>Engagement Rate</h5>
                                                                </div>
                                                                <div className="per-rate">
                                                                    <span>90%</span>

                                                                </div>
                                                            </div>


                                                        </div>


                                                        <div className="create-entertainment-circle">
                                                            <div className="enter-flex-ps">
                                                                <div className="enter-taain-heading">
                                                                    <h1>Entertainment</h1>
                                                                    <p><span><img src={images.redDot} alt="createCricl" />
                                                                    </span>Circle activity tomorrow at 10:00 AM</p>
                                                                </div>
                                                                <div className="dotes-react">
                                                                    {/* <img src={images.dotesReact} alt="dotesReact" /> */}

                                                                </div>

                                                            </div>

                                                            <div className="reation-imoze">
                                                                <div className="avatars">
                                                                    <span><img src={images.firstIcon} alt="firstIcon" /></span>
                                                                    <span><img src={images.avatarTow} alt="avatarTow" /></span>
                                                                    <span><img src={images.avatarThree} alt="avatarThree" /></span>
                                                                    <span><img src={images.avatarFour} alt="avatarfour" /></span>
                                                                    <span><img src={images.avatarFive} alt="avatarfour" /></span>
                                                                    <span className="get-more">+3</span>
                                                                </div>

                                                                <div className="back-button">
                                                                    <img src={images.backButton} alt="backButton" />
                                                                </div>
                                                            </div>

                                                            <div className="engagement-rate">
                                                                <div className="engage-text">
                                                                    <h5>Engagement Rate</h5>
                                                                </div>
                                                                <div className="per-rate">
                                                                    <span>90%</span>

                                                                </div>
                                                            </div>


                                                        </div>




                                                        <div className="create-entertainment-circle">
                                                            <div className="enter-flex-ps">
                                                                <div className="enter-taain-heading">
                                                                    <h1>Entertainment</h1>
                                                                    <p><span><img src={images.redDot} alt="createCricl" />
                                                                    </span>Circle activity tomorrow at 10:00 AM</p>
                                                                </div>
                                                                <div className="dotes-react">
                                                                    {/* <img src={images.dotesReact} alt="dotesReact" /> */}

                                                                </div>

                                                            </div>

                                                            <div className="reation-imoze">
                                                                <div className="avatars">
                                                                    <span><img src={images.firstIcon} alt="firstIcon" /></span>
                                                                    <span><img src={images.avatarTow} alt="avatarTow" /></span>
                                                                    <span><img src={images.avatarThree} alt="avatarThree" /></span>
                                                                    <span><img src={images.avatarFour} alt="avatarfour" /></span>
                                                                    <span><img src={images.avatarFive} alt="avatarfour" /></span>
                                                                    <span className="get-more">+3</span>
                                                                </div>

                                                                <div className="back-button">
                                                                    <img src={images.backButton} alt="backButton" />
                                                                </div>
                                                            </div>

                                                            <div className="engagement-rate">
                                                                <div className="engage-text">
                                                                    <h5>Engagement Rate</h5>
                                                                </div>
                                                                <div className="per-rate">
                                                                    <span>90%</span>

                                                                </div>
                                                            </div>


                                                        </div>


                                                    </div>

                                                </div>


                                            </Tabs.TabPane>



                                            <Tabs.TabPane tab="Encouragement Groups" key="3">

                                                <div className="inner-circle">
                                                    <div className="create-inner-section encouragement-section-grid">


                                                        <div className="create-entertainment-circle">
                                                            <div className="encouragement-groups">

                                                                <div className="sunday-image">
                                                                    <img src={images.sunday} alt="sunday" />
                                                                    <p>Sunday Scaries</p>
                                                                </div>

                                                                <div className="follow-btn-ps">
                                                                    <button>Follow</button>
                                                                </div>

                                                            </div>
                                                        </div>

                                                        <div className="create-entertainment-circle">
                                                            <div className="encouragement-groups">

                                                                <div className="sunday-image">
                                                                    <img src={images.encoutMonday} alt="sunday" />
                                                                    <p>Motivational Monday</p>
                                                                </div>

                                                                <div className="follow-btn-ps">
                                                                    <button>Follow</button>
                                                                </div>

                                                            </div>
                                                        </div>



                                                        <div className="create-entertainment-circle">
                                                            <div className="encouragement-groups">

                                                                <div className="sunday-image">
                                                                    <img src={images.sunday} alt="sunday" />
                                                                    <p>Meditation Station</p>
                                                                </div>

                                                                <div className="follow-btn-ps">
                                                                    <button>Follow</button>
                                                                </div>

                                                            </div>
                                                        </div>



                                                        <div className="create-entertainment-circle">
                                                            <div className="encouragement-groups">

                                                                <div className="sunday-image">
                                                                    <img src={images.sunday} alt="sunday" />
                                                                    <p>Mood food</p>
                                                                </div>

                                                                <div className="follow-btn-ps">
                                                                    <button>Follow</button>
                                                                </div>

                                                            </div>
                                                        </div>



                                                        <div className="create-entertainment-circle">
                                                            <div className="encouragement-groups">

                                                                <div className="sunday-image">
                                                                    <img src={images.sunday} alt="sunday" />
                                                                    <p>Success City</p>
                                                                </div>

                                                                <div className="follow-btn-ps">
                                                                    <button>Follow</button>
                                                                </div>

                                                            </div>
                                                        </div>



                                                        <div className="create-entertainment-circle">
                                                            <div className="encouragement-groups">

                                                                <div className="sunday-image">
                                                                    <img src={images.sunday} alt="sunday" />
                                                                    <p>Success City</p>
                                                                </div>

                                                                <div className="follow-btn-ps">
                                                                    <button>Follow</button>
                                                                </div>

                                                            </div>
                                                        </div>


                                                        <div className="create-entertainment-circle">
                                                            <div className="encouragement-groups">

                                                                <div className="sunday-image">
                                                                    <img src={images.sunday} alt="sunday" />
                                                                    <p>Success City</p>
                                                                </div>

                                                                <div className="follow-btn-ps">
                                                                    <button>Follow</button>
                                                                </div>

                                                            </div>
                                                        </div>


                                                        <div className="create-entertainment-circle">
                                                            <div className="encouragement-groups">

                                                                <div className="sunday-image">
                                                                    <img src={images.sunday} alt="sunday" />
                                                                    <p>Success City</p>
                                                                </div>

                                                                <div className="follow-btn-ps">
                                                                    <button>Follow</button>
                                                                </div>

                                                            </div>
                                                        </div>



                                                    </div>

                                                </div>


                                            </Tabs.TabPane>

                                            <Tabs.TabPane tab="Direct Care Sessions" key="4">

                                                <div className="direct-care-sessions">
                                                    <div className="grid-care-sessions">
                                                        <div className="booked-sessions">
                                                            <p>Booked Sessions : <span>50</span></p>
                                                        </div>

                                                        <div className="booked-sessions">
                                                            <p>Booked Sessions : <span>50</span> </p>
                                                        </div>

                                                        <div className="booked-sessions">
                                                            <p>Booked Sessions : <span>50</span></p>
                                                        </div>

                                                    </div>

                                                    <div className="post-detail-and-count">
                                                        <div className="john-smith-post">
                                                            <div className="profile-and-name">
                                                                <div className="psychiatrist-fa-pa">
                                                                    <div className="profile-picture">
                                                                        <img src={images.userProfileScound} alt="userProfile" />
                                                                    </div>
                                                                    <div className="name-case">
                                                                        <h1>John_smith01 <span><img src={images.codiconVerified} alt="codiconVerified" /></span></h1>
                                                                        <p>Psychiatrist</p>
                                                                    </div>
                                                                </div>

                                                                <div className="options-setting-ps">
                                                                    {/* <img src={images.dotesReact} alt="dotesReact" /> */}
                                                                    <img src={images.signls} alt="signls" />
                                                                </div>

                                                            </div>

                                                            <div className="date-time-amount">
                                                                <div className="amount-inner-sec">
                                                                    <div className="date-row">
                                                                        <div className="date-icons-text">
                                                                            <p><span> <img src={images.grayCalender} alt="grayCalender" /></span>Date</p>
                                                                        </div>
                                                                        <div className="full-date">
                                                                            <p>March 12, 2024 </p>
                                                                        </div>
                                                                    </div>


                                                                    <div className="date-row">
                                                                        <div className="date-icons-text">
                                                                            <p><span> <img src={images.clockIcon} alt="clockIcon" /></span>Time</p>
                                                                        </div>
                                                                        <div className="full-date">
                                                                            <p>10:00 PM - 10:30 PM </p>
                                                                        </div>
                                                                    </div>


                                                                    <div className="date-row">
                                                                        <div className="date-icons-text">
                                                                            <p><span> <img src={images.dollar} alt="dollar" /></span>Amount</p>
                                                                        </div>
                                                                        <div className="full-date">
                                                                            <p>$50</p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="john-smith-post">
                                                            <div className="profile-and-name">
                                                                <div className="psychiatrist-fa-pa">
                                                                    <div className="profile-picture">
                                                                        <img src={images.userProfileScound} alt="userProfile" />
                                                                    </div>
                                                                    <div className="name-case">
                                                                        <h1>John_smith01 <span><img src={images.codiconVerified} alt="codiconVerified" /></span></h1>
                                                                        <p>Psychiatrist</p>
                                                                    </div>
                                                                </div>

                                                                <div className="options-setting-ps">
                                                                    {/* <img src={images.dotesReact} alt="dotesReact" /> */}
                                                                    <img src={images.signls} alt="signls" />
                                                                </div>

                                                            </div>

                                                            <div className="date-time-amount">
                                                                <div className="amount-inner-sec">
                                                                    <div className="date-row">
                                                                        <div className="date-icons-text">
                                                                            <p><span> <img src={images.grayCalender} alt="grayCalender" /></span>Date</p>
                                                                        </div>
                                                                        <div className="full-date">
                                                                            <p>March 12, 2024 </p>
                                                                        </div>
                                                                    </div>


                                                                    <div className="date-row">
                                                                        <div className="date-icons-text">
                                                                            <p><span> <img src={images.clockIcon} alt="clockIcon" /></span>Time</p>
                                                                        </div>
                                                                        <div className="full-date">
                                                                            <p>10:00 PM - 10:30 PM </p>
                                                                        </div>
                                                                    </div>


                                                                    <div className="date-row">
                                                                        <div className="date-icons-text">
                                                                            <p><span> <img src={images.dollar} alt="dollar" /></span>Amount</p>
                                                                        </div>
                                                                        <div className="full-date">
                                                                            <p>$50</p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="john-smith-post">
                                                            <div className="profile-and-name">
                                                                <div className="psychiatrist-fa-pa">
                                                                    <div className="profile-picture">
                                                                        <img src={images.userProfileScound} alt="userProfile" />
                                                                    </div>
                                                                    <div className="name-case">
                                                                        <h1>John_smith01 <span><img src={images.codiconVerified} alt="codiconVerified" /></span></h1>
                                                                        <p>Psychiatrist</p>
                                                                    </div>
                                                                </div>

                                                                <div className="options-setting-ps">
                                                                    {/* <img src={images.dotesReact} alt="dotesReact" /> */}
                                                                    <img src={images.signls} alt="signls" />
                                                                </div>

                                                            </div>

                                                            <div className="date-time-amount">
                                                                <div className="amount-inner-sec">
                                                                    <div className="date-row">
                                                                        <div className="date-icons-text">
                                                                            <p><span> <img src={images.grayCalender} alt="grayCalender" /></span>Date</p>
                                                                        </div>
                                                                        <div className="full-date">
                                                                            <p>March 12, 2024 </p>
                                                                        </div>
                                                                    </div>


                                                                    <div className="date-row">
                                                                        <div className="date-icons-text">
                                                                            <p><span> <img src={images.clockIcon} alt="clockIcon" /></span>Time</p>
                                                                        </div>
                                                                        <div className="full-date">
                                                                            <p>10:00 PM - 10:30 PM </p>
                                                                        </div>
                                                                    </div>


                                                                    <div className="date-row">
                                                                        <div className="date-icons-text">
                                                                            <p><span> <img src={images.dollar} alt="dollar" /></span>Amount</p>
                                                                        </div>
                                                                        <div className="full-date">
                                                                            <p>$50</p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="john-smith-post">
                                                            <div className="profile-and-name">
                                                                <div className="psychiatrist-fa-pa">
                                                                    <div className="profile-picture">
                                                                        <img src={images.userProfileScound} alt="userProfile" />
                                                                    </div>
                                                                    <div className="name-case">
                                                                        <h1>John_smith01 <span><img src={images.codiconVerified} alt="codiconVerified" /></span></h1>
                                                                        <p>Psychiatrist</p>
                                                                    </div>
                                                                </div>

                                                                <div className="options-setting-ps">
                                                                    {/* <img src={images.dotesReact} alt="dotesReact" /> */}
                                                                    <img src={images.signls} alt="signls" />
                                                                </div>

                                                            </div>

                                                            <div className="date-time-amount">
                                                                <div className="amount-inner-sec">
                                                                    <div className="date-row">
                                                                        <div className="date-icons-text">
                                                                            <p><span> <img src={images.grayCalender} alt="grayCalender" /></span>Date</p>
                                                                        </div>
                                                                        <div className="full-date">
                                                                            <p>March 12, 2024 </p>
                                                                        </div>
                                                                    </div>


                                                                    <div className="date-row">
                                                                        <div className="date-icons-text">
                                                                            <p><span> <img src={images.clockIcon} alt="clockIcon" /></span>Time</p>
                                                                        </div>
                                                                        <div className="full-date">
                                                                            <p>10:00 PM - 10:30 PM </p>
                                                                        </div>
                                                                    </div>


                                                                    <div className="date-row">
                                                                        <div className="date-icons-text">
                                                                            <p><span> <img src={images.dollar} alt="dollar" /></span>Amount</p>
                                                                        </div>
                                                                        <div className="full-date">
                                                                            <p>$50</p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="john-smith-post">
                                                            <div className="profile-and-name">
                                                                <div className="psychiatrist-fa-pa">
                                                                    <div className="profile-picture">
                                                                        <img src={images.userProfileScound} alt="userProfile" />
                                                                    </div>
                                                                    <div className="name-case">
                                                                        <h1>John_smith01 <span><img src={images.codiconVerified} alt="codiconVerified" /></span></h1>
                                                                        <p>Psychiatrist</p>
                                                                    </div>
                                                                </div>

                                                                <div className="options-setting-ps">
                                                                    {/* <img src={images.dotesReact} alt="dotesReact" /> */}
                                                                    <img src={images.signls} alt="signls" />
                                                                </div>

                                                            </div>

                                                            <div className="date-time-amount">
                                                                <div className="amount-inner-sec">
                                                                    <div className="date-row">
                                                                        <div className="date-icons-text">
                                                                            <p><span> <img src={images.grayCalender} alt="grayCalender" /></span>Date</p>
                                                                        </div>
                                                                        <div className="full-date">
                                                                            <p>March 12, 2024 </p>
                                                                        </div>
                                                                    </div>


                                                                    <div className="date-row">
                                                                        <div className="date-icons-text">
                                                                            <p><span> <img src={images.clockIcon} alt="clockIcon" /></span>Time</p>
                                                                        </div>
                                                                        <div className="full-date">
                                                                            <p>10:00 PM - 10:30 PM </p>
                                                                        </div>
                                                                    </div>


                                                                    <div className="date-row">
                                                                        <div className="date-icons-text">
                                                                            <p><span> <img src={images.dollar} alt="dollar" /></span>Amount</p>
                                                                        </div>
                                                                        <div className="full-date">
                                                                            <p>$50</p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </Tabs.TabPane>


                                        </Tabs>
                                    </div>

                                </div>

                            </div>


                        </div>

                    </div>

                </div>

                {/* Freeze Account */}
                <Modal
                    title=""
                    className="modal-update"
                    centered
                    open={modal1Open}
                    closable={true}
                    onCancel={() => setModal1Open(false)}
                    footer={false}
                    width={600}  >
                    <div className="add-user-popup">
                        <div className="modal-add-user">
                            <h1>Freeze Account</h1>

                        </div>

                        <div className="description-inner-circle">
                            <div className="wrapper_line">
                                <div className="form-group  annette-black">
                                    <label>{appconstant.accountEmail}</label>
                                    <Textfiled
                                        className='form-control search-iocns '
                                        type='text'
                                        placeholder='Search by Email' />
                                    <p>This email is associated with <span>Annette Black</span></p>
                                </div>


                            </div>
                        </div>


                        <div className="account-btn">
                            <button onClick={() => {
                                setModal1Open(false)
                                setModal2Open(true)
                            }} >Freeze Account</button>
                        </div>


                    </div>
                </Modal>


                {/* Freeze Account  new post*/}
                <Modal
                    title=""
                    className="modal-update"
                    centered
                    open={modal2Open}
                    closable={true}
                    onCancel={() => setModal2Open(false)}
                    footer={false}
                    width={600}  >
                    <div className="add-user-popup">
                        <div className="modal-add-user">
                            <h1>Freeze Account</h1>
                            <div className="user-disp">
                                <p>Please select that what action that user can’t perform  </p>

                            </div>
                        </div>

                        <div className="description-inner-circle">
                            <div className="add-new-post-ps">
                                <p>Add New Post</p>
                                <Switch defaultChecked onChange={onChange3} />
                            </div>

                            <div className="add-new-post-ps">
                                <p>Add Comment</p>
                                <Switch defaultChecked onChange={onChange3} />
                            </div>


                        
                            <div className="form-group number-of-days ">
                                <label>{appconstant.noDays}</label>
                                <Textfiled
                                    className='form-control '
                                    type='number'
                                    placeholder='Enter Days here' />

                                <div className="enter-chevron-down">
                                    <img src={images.chevronDown} alt="chevronDown" />
                                    <img src={images.chevronUP} alt="chevronUP" />
                                </div>
                            </div>
                        </div>


                        <div className="account-btn">
                            <button >Freeze Account</button>
                        </div>


                    </div>
                </Modal>


                {/* Remove post */}
                <Modal
                    title=""
                    className="modal-update"
                    centered
                    open={modal3Open}
                    closable={true}
                    onCancel={() => setModal4Open(false)}
                    footer={false}
                    width={600}  >
                    <div className="add-user-popup">
                        <div className="modal-add-user">
                            <h1>Remove Profile</h1>

                        </div>

                        <div className="description-inner-circle">
                            <div className="wrapper_line">
                                <div className="form-group  annette-black">
                                    <label>{appconstant.accountEmail}</label>
                                    <Textfiled
                                        className='form-control search-iocns '
                                        type='text'
                                        placeholder='Search by Email' />
                                    <p>This email is associated with <span>Annette Black</span></p>
                                </div>


                            </div>
                        </div>


                        <div className="account-btn">
                            <button onClick={() => {
                                setModal3Open(false)
                                setModal5Open(true)
                            }} >Remove Profile</button>
                        </div>


                    </div>
                </Modal>


                {/* Remove post  new post*/}
                <Modal
                    title=""
                    className="modal-update"
                    centered
                    open={modal5Open}
                    closable={true}
                    onCancel={() => setModal5Open(false)}
                    footer={false}
                    width={600}  >
                    <div className="add-user-popup">
                        <div className="modal-add-user">
                            <h1>Remove Post</h1>
                            <div className="user-disp">
                                <p>Please enter reason to remove this post  </p>
                            </div>
                        </div>

                        <div className="description-inner-circle">
                            <div className="form-group">
                                <div className="textarea-label">
                                    <label>{appconstant.message}</label>
                                    <p>0/500</p>
                                </div>
                                <textarea
                                    rows="5" cols="50"
                                    className='form-control-textarea'
                                    type='textarea'
                                    placeholder='Enter Description' />
                            </div>
                        </div>


                        <div className="account-btn remove-post-btn">
                            <button >Send</button>
                        </div>


                    </div>
                </Modal>


                {/* Freeze Account */}
                <Modal
                    title=""
                    className="modal-update"
                    centered
                    open={modal7Open}
                    closable={true}
                    onCancel={() => setModal7Open(false)}
                    footer={false}
                    width={600}  >
                    <div className="add-user-popup">
                        <div className="modal-add-user">
                            <h1>Freeze Account</h1>
                            <div className="user-disp">
                                <p>Please select that what action that user can’t perform  </p>

                            </div>
                        </div>

                        <div className="description-inner-circle">
                            <div className="add-new-post-ps">
                                <p>Add New Post</p>
                                <Switch defaultChecked onChange={onChange3} />
                            </div>

                            <div className="add-new-post-ps">
                                <p>Add Comment</p>
                                <Switch defaultChecked onChange={onChange3} />
                            </div>

                        </div>


                        <div className="account-btn">
                            <button >Freeze Account</button>
                        </div>


                    </div>
                </Modal>

                {/* Freeze Account */}
                <Modal
                    title=""
                    className="modal-update"
                    centered
                    open={modal6Open}
                    closable={true}
                    onCancel={() => setModal6Open(false)}
                    footer={false}
                    width={600}  >
                    <div className="add-user-popup">
                        <div className="modal-add-user remove-profile-title">
                            <h1>Do you really want to</h1>
                            <h1>remove this Profile?</h1>
                        </div>

                        <div className="user-remove-section">
                            <img src={images.maleTable} alt="maleTable" />
                            <h5>Annette Black</h5>
                            <p>ckctm12@gmail.com</p>
                        </div>


                        <div className="account-btn cneter-butn">
                            <button >Remove Profile</button>
                        </div>


                    </div>
                </Modal>

            </div>



        )
    }
export default UsersReport

